// extracted by mini-css-extract-plugin
export default {"liked":"style_liked__is0vq","hosted":"style_hosted__3n00x"};